import { Elements } from "@stripe/react-stripe-js";
import { getStripePublishableKey } from "./utils/getStripePublishableKey/getStripePublishableKey";
import React, { useEffect, useState } from "react";
import { Stripe } from "@stripe/stripe-js";
import { StripeIntegration } from "../../../AppDataProvider/AppDataProvider";
import { StripePaymentForm } from "./StripePaymentForm/StripePaymentForm";
export type StripePaymentProps = {
  onGoBack: () => void;
  onPayAndBook: (bookingIds: string[]) => void;
  stripeIntegration: StripeIntegration;
};
export function StripePayment({
  onGoBack,
  onPayAndBook,
  stripeIntegration
}: StripePaymentProps): React.ReactElement {
  const [stripe, setStripe] = useState<Stripe | null>(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    async function loadStripeScript() {
      try {
        const {
          loadStripe
        } = await import("@stripe/stripe-js");
        const stripeInstance = await loadStripe(getStripePublishableKey(), {
          stripeAccount: stripeIntegration?.accountId
        });
        setStripe(stripeInstance);
      } catch (error) {
        console.error("Failed to load Stripe script:", error);
      } finally {
        setLoading(false);
      }
    }
    void loadStripeScript();
  }, [stripeIntegration]);
  if (loading) {
    return <div>Loading...</div>; // or a spinner/loading component
  }
  if (!stripe) {
    return <div>Failed to load Stripe</div>; // error state
  }
  return <Elements stripe={stripe} data-sentry-element="Elements" data-sentry-component="StripePayment" data-sentry-source-file="StripePayment.tsx">
      <StripePaymentForm onGoBack={onGoBack} onPayAndBook={onPayAndBook} loading={false} data-sentry-element="StripePaymentForm" data-sentry-source-file="StripePayment.tsx" />
    </Elements>;
}
export default StripePayment;